import * as React from "react";
import "./TrackingEvent.scss";

function TrackingEvent(props) {
    const { eventData } = props;
    console.log(eventData);
    /**
     * Get a user fr
     *
     * @param {*} time
     * @returns
     */
    function getDateString(time) {
        // Strip timezone
        const dateObj = new Date(time.split("+")[0]);

        const h = dateObj.getHours();
        const m = dateObj.getMinutes();
        const timeStr = `${h}:${m < 10 ? `0${m}` : m}`;
        const day = dateObj.getDate();
        const month = (dateObj.getMonth() + 1).length > 1 ? dateObj.getMonth() + 1 : `0${dateObj.getMonth() + 1}`;
        const year = dateObj.getFullYear();
        const dateStr = `${day}-${month}-${year}`;
        return `${timeStr} ${dateStr}`;
    }

    if (!eventData) {
        return null;
    }

    return (
        <div className="TrackingEvent rounded p-4 bg-white mb-4 d-xl-flex align-items-center flex-wrap">
            <div className="mr-auto h4 mb-0 font-weight-bold">
                {eventData.title === "Manifested" ? "Manifested" : eventData.milestone}
            </div>
            <div>{getDateString(eventData.eventTime)}</div>
        </div>
    );
}

export default TrackingEvent;
